//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex';
import constants from '~/constants';
import Images from '~/components/scene/Images';
import Videos from '~/components/scene/Videos';

export default {
  name: 'Scene',

  components: {
    Images,
    Videos,
  },

  data() {
    return {
      CDN: process.env.CDN,
      constants,
      tabs: [constants.SCENE__TAB__IMAGES, constants.SCENE__TAB__VIDEOS],
      activeTab: this.$route.query.active || constants.SCENE__TAB__IMAGES,
    };
  },

  computed: {
    ...mapState(['scenes']),
    queryTab() {
      return Number(this.$route.query.active);
    },
  },

  watch: {
    queryTab: {
      handler(val) {
        if (val >= 0) {
          this.activeTab = val;
          this.$router.replace({ query: null });
        }
      },
      immediate: true,
    },
  },

  methods: {
    handleTabClick(tab) {
      this.activeTab = tab;
    },
  },

  async validate({ store, query }) {
    const queryVerification = query.active ? Number(query.active) : true;
    let scenes = null;

    if (queryVerification || queryVerification >= 0) {
      scenes = await store.dispatch('getScenes');
    }

    return (queryVerification || queryVerification >= 0) && !!scenes;
  },
};
